import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=6042b604&scoped=true"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=6042b604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042b604",
  null
  
)

export default component.exports